export default __webpack_public_path__ + "static/media/lic2.7860ae11.svg";